import React from "react";
import { useHistory } from "react-router-dom";
import { scrollToHash } from "./SiteHeader";

const PMDetailPage = () => {
    const history = useHistory();
    return (
        <div>
            These PM tools have the same poor levels presentation that is
            explained <a href="/versus/platforms#detail-section" onClick={(e) => {
                e.preventDefault();
                history.push('/versus/platforms#detail-section');
                scrollToHash('#detail-section');
            }}><u>here</u></a>. Sometimes they give you one line subtasks instead of supporting full text 
            and paragraphs, but that's a long way from ideal.
            <br /><br />
            In addition, traditional project management do views or workspaces in a convenient way.
            For instance, GitHub projects are associated with a repository. So having a workspace "Acme Corp" with
            two views "Development" and "Marketing" would be a nonstarter. Asana comes closest to this by
            allowing workspaces to have multiple projects. However it does not support the concept of a 
            "My work" view where you can see everything relevant to you across views.
            <br /><br />
            Finally, traditional PM tools are just fine with lots of meetings and make no attempt at features
            like approvals or an inbox with rows that link to help wizards.
        </div>
    );
};

export default PMDetailPage;